import React, { useState } from "react";
import { Banner, Typography } from "@reconvert/react-ui-component";
import { Box, Button } from "@chakra-ui/react";
import { useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import QuickSlotSetupModal from "./QuickSlotSetupModal";
import { PageNames } from "../../app/slice/appSlice.model";
import { useTranslation } from "react-i18next";
import { Slot } from "../../models";
const bannerType = "warning";

const SlotWarningBanner = ({ slot }: { slot: Slot }) => {
  const { t } = useTranslation();
  const { activePage } = useAppSelector(selectAppState);
  const [isQuickSetupModalOpen, setIsQuickSetupModalOpen] = useState(false);

  return (
    <Box mx={"16px"} mt={3} p={2}>
      <Banner
        title={`${t("It looks like your slot is not added to the")} ${PageNames[activePage!]}`}
        status={bannerType as any}
        hasBackground
        description=""
        body={
          <Typography variant="body">
            {`${t("You need to add the slot to your")} ${PageNames[activePage!]} ${t("to ensure your customers see it. Click the button below to be guided through the process step-by-step.")}`}
          </Typography>
        }
        footer={
          <Button color="link.color" variant={"unstyled"} onClick={() => setIsQuickSetupModalOpen(true)} size="sm">
            {t("Quick setup")}
          </Button>
        }
      />
      <QuickSlotSetupModal isOpen={isQuickSetupModalOpen} onClose={() => setIsQuickSetupModalOpen(false)} slot={slot} />
    </Box>
  );
};

export default SlotWarningBanner;
